/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import React, { useState,useContext,useEffect } from 'react'
import { FormContext } from '../Component/Forms/FormContext';
import { FormControl, InputLabel, RadioGroup as MuiRadioGroup, FormControlLabel, Radio, FormHelperText } from '@material-ui/core';
import elementValidate from '../Component/validation';

// import  useStyles  from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
export default function RadioGroup(props) {
    const {useStyle} = ThemeControls;
    const classes = useStyle();
    // const { name, label, value, onChange, items } = props;
    const {id, field_type, field_id, field_label,field_disabled_Edit, field_placeholder,field_disabled,field_aline, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,onChange,field_mandatory } = props;
    const { handleChange } = useContext(FormContext)
    const [fieldDisable, setFieldDisable]= useState(field_disabled);
    const field = {
        field_id:field_id,
        field_type:field_type,
        field_disabled:field_disabled,
        field_value:field_value,
        field_helperText:field_helperText,
        field_minlength:field_minlength,
        field_maxlength:field_maxlength,
        field_minvalue:field_minvalue,
        field_maxvalue:field_maxvalue,
        field_value_type:field_value_type,
        field_mandatory:field_mandatory,
        field_options:field_options ,
        field_label:field_label
      }
      function handleBlur(){ 
        elementValidate(field)
      }
// console.log(id)
// console.log(field_disabled_Edit)

      useEffect(()=>{
        if(typeof id==='number'&& field_disabled_Edit==='yes' && field_value){
          setFieldDisable(true)
        }else{
          setFieldDisable(field_disabled)
        }
      },[field_disabled, field_value]);

    return (
        <div className={classes.inputroot}>
           <div style={{display:"flex"}}>
        <InputLabel className={classes.label}>{field_label}</InputLabel>{field_mandatory==="yes"?<span 
        style={{fontSize: "18px",
        color: "#d71729",
        fontWeight: "400",
        lineHeight: "20px",
        transform: "translateY(-2px)"}}>*</span>:null}
        </div>
            <FormControl className={field_aline==="vertical"?null:`${classes.rbdb}`}>
            <MuiRadioGroup 
                // name={name}
                id = {field_id}
                type={field_type}
                disabled={fieldDisable}
                onChange={onChange || (event => handleChange(field_id, {}, event.target.value))}
                defaultValue={field_value}
                value={field_value.toString()}
                onBlur={handleBlur}
               >
                {
                    field_options.map(
                        (option,i) => ((option.value)&&<FormControlLabel key={i} value={option.value} control={<Radio disabled={fieldDisable}/>} label={option.option_label} />)
                    )
                }
            </MuiRadioGroup>
        </FormControl>
        <FormHelperText>{field_helperText}</FormHelperText>
        </div>
    )
}
